import React, { Component } from 'react'
import WithFooter from '../layout/WithFooter'
import Pixel, {PIXEL_ACTIONS} from '../components/utils/Pixel'


class IndexPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <WithFooter>

                <h4>Система дистрибуции билетов KudaGo.com</h4>
                <p className='text-block'>
                    Контактная информация для обращений по вопросам,
                    связанным с продажей билетов на
                    мероприятия:
                </p>
                <p className='text-block'>
                        <strong>Телефон:</strong> +7 (999) 035-04-85 (звонить с 10 до 18 часов по московскому времени)
                        <br />
                        <strong>E-mail:</strong> <a href='mailto:ticket@kudago.com'>ticket@kudago.com</a>
                </p>

                <Pixel action={PIXEL_ACTIONS.VIEW} />

            </WithFooter>
        )
    }
};

export default IndexPage;
